import { defineListener, userScopeCleared, type ModuleListener } from '@krp/client-runtime'

import { forgetStashedSecrets } from '../api/secretHandoff'
import { resourcesReloadRequested } from './commands'
import type { ResourcesPortsFactory } from './ports'

/** Listeners фичи: команда → порт. Состояние модуля им не нужно. */
export function createResourcesListeners<S>(makePorts: ResourcesPortsFactory): ModuleListener<S>[] {
  return [
    defineListener<S, ReturnType<typeof resourcesReloadRequested>>(resourcesReloadRequested.match, (action, api) => {
      const ports = makePorts(api.dispatch)
      if (action.payload.resourceId === null) ports.reloadList()
      else ports.reloadResource(action.payload.resourceId)
    }),
    // Выход или смена пользователя: невостребованный секрет не переживает область человека.
    defineListener<S, ReturnType<typeof userScopeCleared>>(userScopeCleared.match, () => {
      forgetStashedSecrets()
    }),
  ]
}
